module.exports = __webpack_public_path__ + "img/error.9e1008b3.png";